import {useTranslations} from 'use-intl'
import clsx from 'clsx'
import {BasketWithImages} from '~/utils/basket'
import Price from '~/components/common/Price'

type BasketSummaryProps = {
    className?: string
    basket: BasketWithImages
    isRecalculating: boolean
}

const BasketSummary = ({className, basket, isRecalculating}: BasketSummaryProps) => {
    const t = useTranslations('basket.item.summary')
    return (
        <div className={clsx('p-4 space-y-4', className)}>
            <h2 className="text-xl font-medium">{t('title')}</h2>
            <div className="space-y-2">
                <div className="flex flex-row items-center justify-between">
                    <span id="basket-subtotal">{t('subtotal')}</span>
                    <Price
                        aria-labelledby="basket-subtotal"
                        className={clsx('font-medium', isRecalculating && 'animate-pulse')}
                    >
                        {basket.priceItems.display}
                    </Price>
                </div>
                <div className="flex flex-row items-center justify-between">
                    <span id="basket-shipping">{t('shipping')}</span>
                    <Price
                        aria-labelledby="basket-shipping"
                        className={clsx('font-medium', isRecalculating && 'animate-pulse')}
                    >
                        {basket.shipping.price.display}
                    </Price>
                </div>
                {!!basket.discounts?.length && (
                    <div className="flex flex-row items-start justify-between">
                        <span id="basket-discounts">{t('discounts')}</span>
                        <ul>
                            {basket.discounts.map((discount) => (
                                <li
                                    key={discount.type}
                                    className="flex justify-end items-baseline gap-4"
                                >
                                    <span className="text-xs">
                                        {t(`discountType.${discount.type}`)}
                                    </span>
                                    <Price
                                        aria-labelledby="basket-discounts"
                                        className={clsx(
                                            'min-w-16 font-medium text-right',
                                            isRecalculating && 'animate-pulse'
                                        )}
                                    >
                                        {discount.price.display * -1}
                                    </Price>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
            <hr />
            <div className="flex flew-row items-baseline justify-between text-xl">
                <div id="basket-total">
                    <span className="font-medium">{t('total')}</span>
                    <span className="text-sm ml-2">{t('inclVat')}</span>
                </div>
                <Price
                    className={clsx('font-bold', isRecalculating && 'animate-pulse')}
                    aria-labelledby="basket-total"
                >
                    {basket.priceTotal.display}
                </Price>
            </div>
        </div>
    )
}

export default BasketSummary
